module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_leucistic.ea302b73.png";